import React from "react";

const EasySolutions = () => {
  return (
    <section className="revamp-services section-padding revamp-header-spacer">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 mb-5 mb-lg-0">
                    <div className="revamp-reveal">
                        <img src="assets/new-images/skill-up.jpg" alt="Abia Tech Hub Academy" className="img-fluid" style={{borderRadius: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)'}} />
                    </div>
                </div>
                <div className="col-lg-6 pl-lg-5">
                    <div className="section-title">
                      <span className="revamp-section-badge revamp-reveal">Visit Our Academy Today</span>
                      <h1 className="revamp-section-title mb-3 revamp-reveal">Build Skills for the Future</h1>
                      <div className="revamp-reveal">
                        <p className="mb-3" style={{fontWeight: 400, textTransform: 'none'}}>At Abia Tech Hub Academy, we equip you with in-demand skills that power today’s digital world and prepare you for tomorrow’s opportunities.</p>
                        <p className="mb-5" style={{fontWeight: 400, textTransform: 'none'}}>Are you ready to take the next step toward a career in tech? Our academy is designed to help you learn, grow, and succeed through practical training, mentorship, and real-world experience. Whether you're starting your journey or looking to level up, we provide the tools and support you need to thrive in a fast-changing industry.</p>
                        <a href="https://academy.abiatechhub.com/" className="revamp-btn revamp-btn--primary">Get Started <i className="fas fa-arrow-right"></i></a>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default EasySolutions;